import { render, staticRenderFns } from "./df-set.vue?vue&type=template&id=68dd264a"
import script from "./df-set.ts?vue&type=script&lang=ts&external"
export * from "./df-set.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports